import { startOfDay } from 'date-fns';

import { TZDate } from '@date-fns/tz';

export function getServerDate() {
  return startOfDay(new TZDate(new Date(), 'Europe/Moscow'));
}
